import { useParams, Link } from 'react-router-dom';
import { Container } from '@/components/layout/Container';
import { Card, CardContent } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { ArrowLeft, HelpCircle } from 'lucide-react';
import { FadeIn } from '@/components/ui/AnimatedCard';
import { helpArticles } from '@/data/helpArticles';

export function HelpArticle() {
  const { slug } = useParams<{ slug: string }>();
  const article = slug ? helpArticles[slug] : null;

  if (!article) {
    return (
      <Container size="lg" className="py-6">
        <Card>
          <CardContent className="py-12 text-center">
            <HelpCircle className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
            <h2 className="text-xl font-semibold mb-2">Article Not Found</h2>
            <p className="text-muted-foreground mb-4">
              The help article you're looking for doesn't exist.
            </p>
            <Button asChild variant="outline">
              <Link to="/help">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back to Help Center
              </Link>
            </Button>
          </CardContent>
        </Card>
      </Container>
    );
  }

  return (
    <Container size="lg" className="py-6">
      <FadeIn>
        <div className="mb-6">
          <Button asChild variant="ghost" size="sm">
            <Link to="/help">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Help Center
            </Link>
          </Button>
        </div>

        <Card>
          <CardContent className="py-8">
            <h1 className="text-2xl font-bold mb-2">{article.title}</h1>
            <p className="text-muted-foreground mb-6">{article.description}</p>
            <div
              className="prose prose-slate dark:prose-invert max-w-none
                prose-headings:text-foreground prose-headings:font-semibold
                prose-h2:text-xl prose-h2:mt-8 prose-h2:mb-4
                prose-p:text-muted-foreground prose-p:leading-relaxed
                prose-li:text-muted-foreground
                prose-strong:text-foreground prose-strong:font-medium
                prose-ul:my-4 prose-ol:my-4
                prose-li:my-1"
              dangerouslySetInnerHTML={{ __html: article.content }}
            />
          </CardContent>
        </Card>
      </FadeIn>
    </Container>
  );
}
